import { Action } from '@ngrx/store';

/**
 * Created By Elia Rohana on 3/28/19
 */

export enum NodeIdGeneratorActionTypes {
    UPDATE_LAST_NODE_ID = '[node id creator] update node id'
}

export class UpdateNodeId implements Action {
    readonly type = NodeIdGeneratorActionTypes.UPDATE_LAST_NODE_ID;

    constructor(public payload: { id: number }) {
    }
}

export type NodeIdGeneratorAction = UpdateNodeId;
